<template>
  <div>
    <div class="row">
      <div class="col text-center">
        <StepsForWizard :ativo="wizard.ativo"
                        :passos="wizard.passos"
                        class="mb-5"
                        tamanho="sm" />
      </div>
    </div>
    <div v-if="wizard.ativo == 0">
      <div class="row">
        <div class="col">
          <b-form-group>
            <!--            deixamos nascimento bloqueado pois api de pré registro não esta finalizada-->
            <b-form-radio-group
              id="radio-group-1"
              v-model="preRegistro.tipo"
              :options="[{ text: 'Casamento', value: 'Casamento' }, { text: 'Nascimento', value: 'Nascimento' }, { text: 'Óbito', value: 'Obito' }]"
              name="radio-options" />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="pre-registro-id"
                 class="label">
            {{ mapTipoPreRegistroId[preRegistro.tipo] }}
          </label>
          <input id="pre-registro-id"
                 v-model="preRegistro.id"
                 type="text"
                 class="form-control form-control-sm">
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <hr class="hr-secondary">
          <button class="btn btn-light mr-2 btn-sm"
                  @click="cancelPreRegistro()">
            Cancelar
          </button>
          <button class="btn btn-secondary btn-sm"
                  :disabled="!(preRegistro.tipo && preRegistro.id)"
                  @click="buscarPreRegistro()">
            Buscar
          </button>
        </div>
      </div>
    </div>
    <div v-if="wizard.ativo == 1">
      <div class="row">
        <div class="col">
          <label class=""><b>{{ preRegistro.tipo }}</b> a ser importado:</label>
        </div>
      </div>
      <div v-if="preRegistro.tipo == 'Casamento'">
        <div class="row my-1">
          <div class="col">
            <u>Conjuge 1</u> <br>
            <b>cpf:</b> {{ preRegistro.registro.dados.pretendentes.length > 2 ? preRegistro.registro.dados.pretendentes[1].cpf : preRegistro.registro.dados.pretendentes[0].cpf | cpf }} <br>
            <b>nome:</b> {{ preRegistro.registro.dados.pretendentes.length > 2 ? nameAdapter(preRegistro.registro.dados.pretendentes[1]) : nameAdapter(preRegistro.registro.dados.pretendentes[0]) }}
          </div>
          <div class="col">
            <u>Conjuge 2</u> <br>
            <b>cpf:</b> {{ preRegistro.registro.dados.pretendentes.length > 2 ? preRegistro.registro.dados.pretendentes[2].cpf : preRegistro.registro.dados.pretendentes[1].cpf | cpf }} <br>
            <b>nome:</b> {{ preRegistro.registro.dados.pretendentes.length > 2 ? nameAdapter(preRegistro.registro.dados.pretendentes[2]) : nameAdapter(preRegistro.registro.dados.pretendentes[1]) }}
          </div>
        </div>
      </div>
      <div v-if="preRegistro.tipo == 'Nascimento'">
        <div class="row my-1">
          <div class="col">
            <b>DNV:</b> {{ preRegistro.registro.dados.registrado.dnv }} <br>
            <b>Nome:</b> {{ preRegistro.registro.dados.registrado.nome }} <br>
            <b>Data:</b> {{ preRegistro.registro.dados.registrado.dataHoraNascimento | date }}
          </div>
        </div>
      </div>
      <div v-if="preRegistro.tipo == 'Obito'">
        <div class="row my-1">
          <div class="col">
            <b>DO:</b> {{ preRegistro.registro.dados.registrado.do }} <br>
            <b>Nome:</b> {{ preRegistro.registro.dados.registrado.nome }} <br>
            <b>Data:</b> {{ preRegistro.registro.dados.registrado.dataNascimento | date }}
          </div>
        </div>
      </div>
      <div v-if="preRegistro.tipo == 'Nascimento'" />
      <div class="row">
        <div class="col text-right">
          <hr class="hr-secondary">
          <button class="btn btn-light mr-2 btn-sm"
                  @click="wizard.ativo = 0">
            Voltar
          </button>
          <button class="btn btn-secondary btn-sm"
                  @click="importarPreRegistro()">
            Confirmar importação
          </button>
        </div>
      </div>
    </div>
    <div v-if="wizard.ativo == 2">
      <div class="row text-center">
        <div class="col">
          <label class="text-secondary label">Registro importado com sucesso!</label>
        </div>
      </div>
      <div class="row text-center">
        <div class="col">
          <b-link v-if="preRegistro.tipo == 'Nascimento'"
                  class="btn btn-secondary"
                  :to="{ name: 'cadastro_nascimento', params: { idNasc: rascunhoId }}"
                  target="_blank">
            Ir para o rascunho gerado
          </b-link>
          <b-link v-if="preRegistro.tipo == 'Casamento'"
                  class="btn btn-secondary"
                  :to="{ name: 'habilitar_casamento', params: { id: rascunhoId }}"
                  target="_blank">
            Ir para o rascunho gerado
          </b-link>
          <b-link v-if="preRegistro.tipo == 'Obito'"
                  class="btn btn-secondary"
                  :to="{ name: 'editar_obito_rascunho', params: { id: rascunhoId }}"
                  target="_blank">
            Ir para o rascunho gerado
          </b-link>
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <hr class="hr-secondary">
          <button class="btn btn-outline-secondary btn-sm mr-1"
                  @click="newImport()">
            Importar novo
          </button>
          <button class="btn btn-secondary btn-sm"
                  @click="cancelPreRegistro()">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import StepsForWizard from "@/components/SofiaRei/StepsForWizard"

  /* services */
  import PreRegistroService from "@/services/PreRegistroService"

  /* others */
  import { mapGetters } from "vuex"

  export default {
    name: "PreRegistro",
    components: {
      StepsForWizard
    },
    data () {
      return {
        rascunhoId: null,
        preRegistro: {
          registro: null,
          tipo: 'Casamento',
          id: null
        },
        wizard: {
          ativo: 0,
          passos: [
            { texto: 'Buscar', active: false },
            { texto: 'Confirmar importação', active: false },
            { texto: 'Finalizar', active: false }
          ]
        },
        mapTipoPreRegistroId: {
          'Nascimento': 'DNV',
          'Casamento': 'ID Pré Registro',
          'Obito': 'DO',
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorioObj: 'auth/getCartorioObj',
        user: 'auth/getUser'
      })
    },
    methods: {
      async buscarPreRegistro () {
        try {
          loader({ active: true, text: 'Importando Pré-Registro' })

          // buscamos
          const { data } = await PreRegistroService.getRegistro({ ...this.preRegistro })

          this.preRegistro.registro = data

          this.wizard.ativo++
        } catch (e) {
          displayMessage('error', 'Atenção!', 'Erro ao buscar pré registro. Tente novamente, caso o erro persistir, contate o suporte.')
        } finally {
          loader({ active: false, text: '' })
        }
      },

      async importarPreRegistro () {
        try {
          loader({ active: true, text: 'Importando Pré-Registro' })

          // buscamos
          const data = await PreRegistroService.importRegistro({ ...this.preRegistro.registro, tipo: this.preRegistro.tipo, cartorio: this.cartorioObj })

          // mudamos a tela do wizard caso tenha sido gerado o rascunho
          if (data.rascunho_id) {
            this.rascunhoId = data.rascunho_id
            this.wizard.ativo++
          }
        } catch (e) {
          displayMessage('error', 'Atenção!', 'Erro ao importar pré registro. Tente novamente, caso o erro persistir, contate o suporte.')
        } finally {
          loader({ active: false, text: '' })
        }
      },

      cancelPreRegistro () {
        this.wizard.ativo = 0
        this.preRegistro.registro = null
        this.preRegistro.id = null
        this.$emit('onCloseModal')
      },

      newImport () {
        this.wizard.ativo = 0
        this.preRegistro.registro = null
        this.preRegistro.id = null
      },
      nameAdapter (pretendente) {
        return !!pretendente.novoNome ? pretendente.novoNome : pretendente.nome
      }
    }
  }
</script>

<style scoped>

</style>
